import axios from 'axios';
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'
import store from '../../../Store';
import getServerModules from "./server_modules_get";

function _success(success) {
    return {type: 'DELETE_SERVER_MODULE_SUCCESS', success}
}

function _error(error) {
    return {type: 'DELETE_SERVER_MODULE_ERROR', error}
}

function _processing(processing) {
    return {type: 'DELETE_SERVER_MODULE_PROCESSING', processing}
}

function deleteServerModule(id) {
    return (dispatch) => {

        dispatch(_processing(true));
        dispatch(_success(null));
        dispatch(_error(null));

        let config = {
            headers: {'Authorization': 'Bearer ' + loginToken()},
        };

        axios.delete(apiBaseUrl(`admin/servers/${id}`), config)

            .then(res => {
                dispatch(_success(res));
                dispatch(_processing(false));
                handleSuccess("Server deleted successfully");
                store.dispatch(getServerModules());
            }).catch(error => {
            dispatch(_error(error));
            dispatch(_processing(false));
            handleError(error)
        });
    }
}

export default deleteServerModule;